import { Paper, Typography, Button, Modal, FormGroup, TextField, Dialog, TableRow, TableHead, Table, TableCell, FormControl, Select, MenuItem, InputLabel } from "@material-ui/core";
import StickyReminderBanner from "./stickybanner.js"
import { makeStyles } from "@material-ui/core/styles";
import { useState, useEffect } from "react";
import { auth } from "../index";
import {  signOut } from "firebase/auth";
import { useContext } from "react";
import { AuthContext } from "./authContext";
import useSocket from './socket'; // The custom hook
import { io } from 'socket.io-client';
import Loading from "./loading";
import {preventDoubleClick} from "./preventDC.js"
import {url as serverurl} from "../api/customerapi.js"
import {servermarker} from "./serverManager.js"
import newDataSound from '../sound.wav'; // Add a notification sound file
import {
  fetchActiveFupTrips,
  getactivefunnellength,
  fetchActiveFupTripsbyTripOwner,
  fetchEmployees,
  fetchInfo,
  loginemail,
  searchTripsbyStartDate3,
  fetchopentasks,
  fetchLeadsbyName,
  fetchIncomingCalls,
  fetchTripsbyNumber,
  fetchLeadsbyNumber,
  fetchcurrentreport,
  fetchaicurrentreport,
  fetchCustomerbyNumber,
  get12pmreport,
  searchTripsbycreateddateandOwner,
  searchpotentialhot,
  fetchTripsbyName,
  fetchLeads10mins,
  fetchtaskcount,
  updatelogout,
  getsignin,
  reactivatebyNumber,
  getmanualfr, fetchpintrip, fetchAsset
} from "../api/customerapi";
import GetRole from "./user";
import { red } from "@material-ui/core/colors";
import Hdef from "../HotDef.png";
import { styled } from '@mui/system';
import DateCalc, { newgetqualitylead, reversesortByKey, getLastTenChars, findCommonElements, getSumByKey, getOfficeHourDiff, removeDuplicates } from "./date";
import moment from "moment";

  const BlinkingText = styled(Typography)({
    // animation: 'blink 1s steps(2, start) infinite',
    // '@keyframes blink': {
    //   to: { visibility: 'hidden' },
    // },
    color: 'red',
    animation: 'slowBlink 2s ease-in-out infinite',
  '@keyframes slowBlink': {
    '0%, 100%': { opacity: 1 },
    '50%': { opacity: 0 },
  },
  });

  const BlinkingText2 = styled(Typography)({
    fontSize:'72px',
    color: 'red',
    animation: 'slowBlink 2s ease-in-out infinite',
  '@keyframes slowBlink': {
    '0%, 100%': { opacity: 1 },
    '50%': { opacity: 0 },
  },
  });

  const BlinkingText3 = styled(Typography)({
    fontSize:'128px',
    color: 'red',
    animation: 'slowBlink 2s ease-in-out infinite',
  '@keyframes slowBlink': {
    '0%, 100%': { opacity: 1 },
    '50%': { opacity: 0 },
  },
  });

const useStyles = makeStyles((theme) => ({
  paper: {
    marginLeft: theme.spacing(10),
    marginRight: theme.spacing(10),
    marginBottom: theme.spacing(5),
    marginTop: theme.spacing(4),
    justifyContent: "center",
    backgroundColor: "#f3fafa",
    border: "1px solid #494a3b"
  },
  modalText: {
    marginLeft: theme.spacing(30),
    marginRight: theme.spacing(4),
    width: theme.spacing(120),
    marginTop: theme.spacing(10),
    marginBottom: theme.spacing(2),
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#f3fafa",
  },
  headertext2: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    marginLeft: theme.spacing(3),
    color: "#a8020b",
  },
  headertext: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    marginLeft: theme.spacing(3),
    
  },
  button: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: theme.spacing(14),
    height: theme.spacing(5),
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    fontSize: 10,
  },
  link: {
    margin:4
  },
  red: {
      color:red
    },
}));

// const socket = io(serverurl, {
//   transports: ['websocket'], // Ensure the correct transport method is used
// });

const Navbar = () => {
  // const socket = useSocket(serverurl);
  // console.log(serverurl)
  const classes = useStyles();
  const currenturl=window.location.href
  const url1=currenturl.split('/')
  const url=url1[0]+"//"+url1[1]+url1[2]
  //const { appData, loading } = useAppData();
  const { User } = useContext(AuthContext);
  //console.log(User)
  if (User == "abc") {
    alert("Sign In to use application OR Wrong link OR Login link has expired");
    localStorage.clear();
    window.location = "/";
  }
  const [myfr, setmyfr] = useState(null);
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [open3, setOpen3] = useState(false);
  const [open5, setOpen5] = useState(false);
  const [showdef, setshowdef] = useState(false);
  const [open4, setOpen4] = useState(false);
  const [opentable2, setopentable2] = useState(false);
  const [opentable3, setopentable3] = useState(false);
  const [loading2, setloading2] = useState(false);
  const [spname, setspname] = useState("");
  const [funnellength, setfunnellength] = useState(0);
  const [currentreportdata, setcurrentreportdata] = useState(null);
  const [emp, setemp]=useState([]);
  const [leaddisplayarr, setleaddisplayarr]=useState([]);
  const [hotdisplayarr, sethotdisplayarr]=useState([]);
  const [currentset, setcurrentset]=useState([]);
  const [tripData, settripData]=useState([]);
  const [leadData, setleadData]=useState([]);
  const [custData, setcustData]=useState([]);
  const [convtripData, setconvtripData]=useState([]);
  const [info, setinfo]=useState(null);
  const [manualfr, setmanualfr]=useState(0);
  const [pintrips, setpintrips]=useState(0);
  const [counter, setcounter]=useState(null);
  const [filterData, setfilterData]=useState(null);
  const [eData, seteData]=useState(null);
  const [taskcount, settaskcount]=useState("");
  const [taskcount2, settaskcount2]=useState("");
  const [taskcount3, settaskcount3]=useState("");
  const [taskcount4, settaskcount4]=useState("");
  const [taskcount5, settaskcount5]=useState("");
  const [taskcount6, settaskcount6]=useState("");
  const [taskcount7, settaskcount7]=useState("");
  const [empall, setempall]=useState([])
  const [l1tasks, setl1tasks]=useState(null)
  const [l2tasks, setl2tasks]=useState(null)
  const [l3tasks, setl3tasks]=useState(null)
  const [server, setserver]=useState({
    server_name:""
  });
  const [searchData3, setsearchData3]=useState({})
 
  const [tasksLoading, setTasksLoading] = useState(false);
  const [followupData, setfollowupData] = useState([]);
  // const currenturl=window.location.href;

  //   const [User, setUser] = useState(currenturl);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleOpen2 = () => {
    setOpen2(true);
  };

  const handleOpen3 = async() => {
    const data = await fetchEmployees();
    const temp=data.data.filter(e=>e.short_name==cuser && e.role !=="Ex-employee")
    //console.log(temp)
    alert("PL Pending: "+temp[0].pl+" || SL Pending: "+temp[0].sl+" || Total Pending: "+(temp[0].pl+temp[0].sl)+" || "+temp[0].holiday_details)
  };

  const handleOpen4 = async() => {
    let set=[]
    var temp={}
    const data = await fetchIncomingCalls();
    //console.log(data.data)
    for(let i=0; i<data.data.length; i++){
      const data2 = await fetchTripsbyNumber(parseInt(data.data[i].caller_id_number));
      //console.log(data2.data)
      if(data2.data.length==0){
        const data3 = await fetchLeadsbyNumber(data.data[i].caller_id_number);
        //console.log(data3.data)
        if(data2.data.length==0){
          temp={
            trip_id:0,
            number:data.data[i].caller_id_number,
            name:"NA",
            type:"Not found",
            owner:"NA"
          }
        }else{
        const final=reversesortByKey(data3.data, "lead_id")
        temp={
          trip_id:final[0].lead_id,
          number:data.data[i].caller_id_number,
          name:final[0].lead_name,
          type:"Lead",
          owner:final[0].lead_owner,
        }
      }
      }else{
      const finaldataset=reversesortByKey(data2.data, "trip_id")
      temp={
        trip_id:finaldataset[0].trip_id,
        number:data.data[i].caller_id_number,
        name:finaldataset[0].cust_name,
        type:"Trip",
        owner:finaldataset[0].trip_owner
      }
    }
      set.push(temp)
    }
    console.log(set)
    setOpen4(true)
    setcurrentset(set)
  };

  

  const handleClose = () => {
    setOpen(false);
  };

  const handleClose2 = () => {
    setOpen2(false);
  };

  const handleClose3 = () => {
    setOpen3(false);
  };

  const handleClose5 = () => {
    setOpen5(false);
  };

  const handleClose4 = () => {
    setOpen4(false);
  };

  const getTL=(name)=>{
    if(emp && emp.length>0){
    const temp=emp.filter(e=>e.short_name==name)
    return temp && temp.length>0 && "reporting_manager" in temp[0]?temp[0].reporting_manager:""
    }else{
      return ""
    }
  }

  const body = (
    <div className={classes.modalText}>
      <h2 className={classes.headertext}>User Guide</h2>
      <p className={classes.headertext}>
        $ CRM will open at the homepage where you can see pending followups{" "}
        <br />
        $ Go to Add customer and add customer details <br />
        $ Then add trip for a customer and create next followup <br />
        $ Once followup is done, create the next followup. The previous followup
        will auto-close <br />
        $ Take actions on all followups shown on Homepage <br />
        -------------------------------------------------------------- <br />
        $ Put as much data as possible <br />
        $ Enter data correctly. There is no validation done. Do not enter text
        in case of numbers <br />
      </p>
    </div>
  );

  const body2 = (
    <div className={classes.modalText}>
      <h2 className={classes.headertext}>Daily Process</h2>
      <p className={classes.headertext}>
      10:30 - 11:00 ---	Hot & Potential leads call <br/>
11:00 - 11:30	--- Work on HOT edit <br/>
11:30 - 13:00	--- (First Round 10 Leads) Call on new leads, Quote Share on new leads, Call recording Share <br/>
13:00 - 13:30	--- Follow-up (Whatsapp Only) <br/>
13:30 - 14:00	--- Quote edit on new leads and follow up revised quote <br/>
14:00 - 15:00	--- Lunch <br/>
15:00 - 15:30	--- (Second Round 6 Leads)  Call & Quote Share <br/>
15:30 - 16:00 --- Call on new open lead and share sample package if call not picked <br/>
	
16:00 - 17:00	--- Pending work, Help from TL , TEA Break <br/>
17:00 - 17:30	--- Training <br/>
17:30 - 19:00	--- Follow-up, CALL ON EVERY FOLLOW - UP & Quote edit, MARK HOT AS PER PROCESS <br/>
19:00 - 19:30 --- Reporting 
      </p>
    </div>
  );

  const body3=(
    <div className={classes.modalText}>
      <h2 className={classes.headertext}>Daily Process</h2>
      <p className={classes.headertext}>
     Verify status of Yesterday projections
    Update HOT & High profit trips
    2PM check effective calls
    Tickets check 
    Booker trips check 
    QE check 
    Hot marking 
      </p>
    </div>
  )

  const logout = async(e) => {
    e.preventDefault();
    const token = localStorage.getItem("jwtToken");
    const token2 = localStorage.getItem("appData");
    if(token2){
      console.log("Deleting local storage")
      localStorage.removeItem("appData");
    }
    if(token){
      localStorage.removeItem("jwtToken");
    }else{
      signOut(auth).then(
       
        console.log("user signed out")
    );
    const data=await updatelogout(User.email)
    console.log(data.data)
    }
    window.location = "/";
  };

   const logout2 = async(email) => {
  
    const token = localStorage.getItem("jwtToken");
    const token2 = localStorage.getItem("appData");
    if(token2){
      console.log("Deleting local storage")
      localStorage.removeItem("appData");
    }
    if(token){
      localStorage.removeItem("jwtToken");
    }else{
      signOut(auth).then(
       
        console.log("user signed out")
    );
    const data=await updatelogout(email)
    console.log(data.data)
    }
    window.location = "/";
  };

  const { cuser, role, employeelist, destinationlist, loading } = GetRole();
  

  const getEmployees = async () => {
    try{
    //const data = await fetchEmployees();
    setempall(employeelist)
    const empsplist = employeelist.filter((emp) => emp.role !== "Ex-employee");
    seteData(employeelist.filter(emp => emp.role=="TL" || emp.role=="SME"))
    // const temp=empsplist.filter(e=>e.short_name==cuser)
    // console.log(temp)
    // setcurrentuser(temp)
    setemp(empsplist);
  }catch(err){
    console.log(err)
  }
  };
  
  const getInfo = async () => {
    try{
    const data = await fetchInfo();
    //const empsplist = data.data.filter((emp) => emp.role !== "Ex-employee");
    // const d=new Date()
    // d.setHours(14,0,0)
    // console.log(d)

    // if(new Date().getTime()>d.getTime()){
    //   setinfo("ABC")
    // }else{
      setinfo(data.data[0]);
    // }
    //const custdatalistfromdb= data.data
    //console.log(empsplist)
    //autoLogoutAtMidnight()
  }catch(err){
    console.log(err)
  }
  };

  const getTeam=(emp)=>{
    if(emp && emp!=="" && employeelist && employeelist.length>0){
          const x=employeelist.filter(e=>e.short_name==emp)
          if(x && x.length>0 && "role" in x[0]){
          return x[0].role
          }else{
            // console.log(emp)
            // console.log(x)
            return ""
          }
    }else{
          return ""
    }
}

  const getjc=async()=>{
    try{
      const ten=DateCalc(10)
      const data=await searchTripsbyStartDate3(new Date(), new Date(ten))
    
      //console.log(data.data)
      // const temp=data.data.filter(t=>"booking" in t && "transfer_state" in t.booking && t.booking.transfer_state=="Just Converted")
      const temp2=data.data.map(t=>t.trip_id)
      setconvtripData(temp2.toString())
      //gettasks()
    }catch(err){
      console.log(err)
    }
  }

  const hasDeadlinePassed=(deadlineDate, deadlineTime) =>{
  const deadline = moment(`${deadlineDate} ${deadlineTime}`, "YYYY-MM-DD HH:mm");
  return moment().isAfter(deadline);
}

   const gettasks=async()=>{
    try{
      
      const data=await fetchopentasks()
      console.log("Running tasks:")
      console.log(data.data)
      const temp=data.data.filter(t=>"assigned_to" in t && (getTeam(t.assigned_to)=="TL" || getTeam(t.assigned_to)=="Manager"))
      
      settaskcount2(temp.length)
      const temp2=data.data.filter(t=>"assigned_to" in t && (getTeam(t.assigned_to)=="HR"))
      settaskcount3(temp2.length)
      const temp3=data.data.filter(t=>"assigned_to" in t && (getTeam(t.assigned_to)=="Operations" || getTeam(t.assigned_to)=="Operations-TL") && (new Date().getTime()-new Date(t.createdAt).getTime()>(1000*60*60*24)))
      settaskcount4(temp3.length)
      const temp4=data.data.filter(t=>"assigned_to" in t && (getTeam(t.assigned_to)=="Support" && (new Date().getTime()-new Date(t.createdAt).getTime()>(1000*60*60*24))))
      settaskcount5(temp4.length)
      const temp5=data.data.filter(t=>"assigned_to" in t && (getTeam(t.assigned_to)=="Operations" || getTeam(t.assigned_to)=="Operations-TL") && (t.task_category=="Book Hotel Online" || t.task_category=="Book Hotel Offline"))
      settaskcount6(temp5.length)
      const temp6=temp5.filter(t=>hasDeadlinePassed(t.deadline_date, t.deadline_time) && t.task_status!=="Task Done")
      settaskcount7(temp6.length)
      //console.log(temp.length, temp2.length, temp6.length)

      var l1=cuser, l2="", l3=""
      var l2temp=employeelist.filter(e=>e.reporting_manager==l1)
      if(l2temp.length>0){
        l2=l2temp.map(e=>e.short_name)
        var l3temp=employeelist.filter(e=>l2.includes(e.reporting_manager))
          if(l3temp.length>0){
            l3=l3temp.map(e=>e.short_name)
          }
      }
      var revisedtasklist=data.data.filter(t=>!("task_category" in t && t.task_category=="Refund"))
      const l3tasklist=revisedtasklist.filter(t=>t.task_status=="Back to Owner"?((t.assigned_to==l1 || l2.includes(t.assigned_to) || l3.includes(t.assigned_to)) && t.task_status=="Open" && ((t.task_priority=="P1" && getOfficeHourDiff(new Date(t.createdAt), new Date())>4) || (t.task_priority=="P2" && getOfficeHourDiff(new Date(t.createdAt), new Date())>9) || (t.task_priority=="P3" && getOfficeHourDiff(new Date(t.createdAt), new Date())>18))):((t.assigned_by==l1 || l2.includes(t.assigned_by) || l3.includes(t.assigned_by)) && t.task_status=="Open" && ((t.task_priority=="P1" && getOfficeHourDiff(new Date(t.createdAt), new Date())>4) || (t.task_priority=="P2" && getOfficeHourDiff(new Date(t.createdAt), new Date())>9) || (t.task_priority=="P3" && getOfficeHourDiff(new Date(t.createdAt), new Date())>18))))
      var templ3=l3tasklist.map(t=>t.task_id)
      //console.log(templ3)
       const l2tasklist=revisedtasklist.filter(t=>t.task_status=="Back to Owner"?((t.assigned_to==l1 || l2.includes(t.assigned_to) || l3.includes(t.assigned_to)) && !templ3.includes(t.task_id) && t.task_status=="Open" && ((t.task_priority=="P1" && getOfficeHourDiff(new Date(t.createdAt), new Date())>1) || (t.task_priority=="P2" && getOfficeHourDiff(new Date(t.createdAt), new Date())>4) || (t.task_priority=="P3" && getOfficeHourDiff(new Date(t.createdAt), new Date())>9))):((t.assigned_by==l1 || l2.includes(t.assigned_by) || l3.includes(t.assigned_by)) && !templ3.includes(t.task_id) && t.task_status=="Open" && ((t.task_priority=="P1" && getOfficeHourDiff(new Date(t.createdAt), new Date())>1) || (t.task_priority=="P2" && getOfficeHourDiff(new Date(t.createdAt), new Date())>4) || (t.task_priority=="P3" && getOfficeHourDiff(new Date(t.createdAt), new Date())>9))))
      var templ2=l2tasklist.map(t=>t.task_id)
      //setl2tasks(templ2)
      const l1tasklist=revisedtasklist.filter(t=>t.task_status=="Back to Owner"?((t.assigned_to==l1 || l2.includes(t.assigned_to) || l3.includes(t.assigned_to)) && t.task_status=="Open" && !templ2.includes(t.task_id) && !templ3.includes(t.task_id)):((t.assigned_by==l1 || l2.includes(t.assigned_by) || l3.includes(t.assigned_by)) && t.task_status=="Open" && !templ2.includes(t.task_id) && !templ3.includes(t.task_id)))
      var templ1=l1tasklist.map(t=>t.task_id)
      

      const inc3=revisedtasklist.filter(t=>(t.assigned_to==l1 || l2.includes(t.assigned_to) || l3.includes(t.assigned_to)) 
      && !(t.task_status=="Task Done" || t.task_status=="Close") 
      && ((t.task_priority=="P1" && getOfficeHourDiff(new Date(t.createdAt), new Date())>8) || (t.task_priority=="P2" && getOfficeHourDiff(new Date(t.createdAt), new Date())>16) || (t.task_priority=="P3" && getOfficeHourDiff(new Date(t.createdAt), new Date())>24)))
      templ3=removeDuplicates([...l3tasklist,...inc3],"task_id")
      

      const inc2=revisedtasklist.filter(t=>(t.assigned_to==l1 || l2.includes(t.assigned_to) || l3.includes(t.assigned_to)) 
      && !(t.task_status=="Task Done" || t.task_status=="Close") && !templ3.includes(t.task_id)
      && ((t.task_priority=="P1" && getOfficeHourDiff(new Date(t.createdAt), new Date())>8) || (t.task_priority=="P2" && getOfficeHourDiff(new Date(t.createdAt), new Date())>16) || (t.task_priority=="P3" && getOfficeHourDiff(new Date(t.createdAt), new Date())>24)))
       templ2=removeDuplicates([...l2tasklist,...inc2],"task_id")
     


      

       var tdlist=data.data.filter(t=>("task_status" in t && t.task_status=="Task Done"))

        const l3tdtasklist=tdlist.filter(t=>((t.assigned_by==l1 || l2.includes(t.assigned_by) || l3.includes(t.assigned_by)) && ((t.task_priority=="P1" && getOfficeHourDiff(new Date(t.task_done_date), new Date())>4) || (t.task_priority=="P2" && getOfficeHourDiff(new Date(t.task_done_date), new Date())>9) || (t.task_priority=="P3" && getOfficeHourDiff(new Date(t.task_done_date), new Date())>18))))
      templ3=removeDuplicates([...l3tasklist,...l3tdtasklist],"task_id")
      console.log(templ3)
      var templ3list=templ3.map(t=>t.task_id)
       const l2tdtasklist=tdlist.filter(t=>((t.assigned_by==l1 || l2.includes(t.assigned_by) || l3.includes(t.assigned_by)) && !l3tdtasklist.includes(t.task_id) && ((t.task_priority=="P1" && getOfficeHourDiff(new Date(t.task_done_date), new Date())>4) || (t.task_priority=="P2" && getOfficeHourDiff(new Date(t.task_done_date), new Date())>9) || (t.task_priority=="P3" && getOfficeHourDiff(new Date(t.task_done_date), new Date())>18))))
      templ2=removeDuplicates([...l2tasklist,...l2tdtasklist],"task_id")
      var templ2list=templ2.map(t=>t.task_id)
      templ2list=templ2list.filter(t=>!templ3list.includes(t))
      //console.log(templ2)
      const l1tdtasklist=tdlist.filter(t=>((t.assigned_by==l1 || l2.includes(t.assigned_by) || l3.includes(t.assigned_by)) && !l2tdtasklist.includes(t.task_id) && !l3tdtasklist.includes(t.task_id) && ((t.task_priority=="P1" && getOfficeHourDiff(new Date(t.task_done_date), new Date())>4) || (t.task_priority=="P2" && getOfficeHourDiff(new Date(t.task_done_date), new Date())>9) || (t.task_priority=="P3" && getOfficeHourDiff(new Date(t.task_done_date), new Date())>18))))
      templ1=removeDuplicates([...l1tasklist,...l1tdtasklist],"task_id")
      var templ1list=templ1.map(t=>t.task_id)
      templ1list=templ1list.filter(t=>!templ2list.includes(t))

       setl3tasks(templ3list)
        setl2tasks(templ2list)
        setl1tasks(templ1list)

     
    }catch(err){
      console.log(err)
    }
  }

  // console.log(l1tasks)
  // console.log(l2tasks)
  // console.log(l3tasks)

  const getlead=async()=>{
    const data=await fetchLeads10mins()
    console.log(data.data)
    const temp=data.data.filter(leaddata=>leaddata.lead_platform=="Meta" && (newgetqualitylead(leaddata)!=="Iron" && newgetqualitylead(leaddata)!=="Copper"))
    const temp2=temp.map(l=>l.lead_id)
    setcounter(temp2)
  }

  async function autoLogoutAtMidnight() {
   try{
    if(User && "email" in User && User.email!=="debayan.ghosh@jetovacations.com"){
    const data=await getsignin(User.email)
    console.log(data.data)
    alert("Logout")
    //console.log(new Date(data.data[0].signin_time).getTime())
    //console.log(new Date(DateCalc(0)).getTime())
   if(data.data.length>0 && "signin_time" in data.data[0] && (new Date(data.data[0].signin_time).getTime())<(new Date(DateCalc(0)).getTime()-1000*60*60*5.5)){
    console.log(new Date(data.data[0].signin_time).getTime())
    console.log(new Date(DateCalc(0)).getTime())
    console.log(data.data[0])
                      // signOut(auth).then(
         
                      //     console.log("user signed out")
                      // );
    logout2(data.data[0].user)

   window.location = ("/");
  }
}
}catch(err){
  console.log(err)
}
  
  }

  async function forceLogoutByEmail() {
   try{
    var x=prompt("Enter email:")
    if(x && x.trim()!==""){
    const email=x.trim()
    var data=await getsignin(email)
    if(data.data.length==0){
      //retry lowercased in case the entered id differs only by case
      data=await getsignin(email.toLowerCase())
    }
    console.log(data.data)
   if(data.data.length>0 && "signin_time" in data.data[0]){
    const target=data.data[0].user
    console.log(target)
    //only flip the target's server side session. The current user's own
    //firebase session and local storage must be left untouched
    const result=await updatelogout(target)
    console.log(result.data)
    if(User && User.email==target){
      //forcing a logout on yourself, so clear this session too
      logout2(target)
    }else{
      alert("Force logout done for: "+target)
    }
  }else{
    alert("No record found")
  }
}else{
  alert("No email found")
}
}catch(err){
  console.log(err)
  alert("Force logout failed. Try again")
}

  }

  const getmanualfrinfo=async()=>{
    try{
      const sales=empall.filter(e=>e.role=="Sales" || e.role=="SME")
      const sales2=sales.map(e=>e.short_name)
      const data=await getmanualfr()
      //console.log(data.data)
      const valid=data.data.filter(l=>new Date().getTime()-new Date(l.manual_fast_reach_attempted_time).getTime()<1000*60*30 && !("work_complete" in l && l.work_complete))
      var temp=data.data.filter(l=>sales2.includes(l.lead_owner) && l.lead_owner==cuser && !("work_complete" in l && l.work_complete))
      setmyfr(temp.map(l=>l.lead_id))
      //console.log(temp)
      setmanualfr(valid)
    }catch(err){
      console.log(err)
    }
  }

  // useEffect(() => {
  //  gettasks()
    

  // }, [empall]);

  // useEffect(() => {
  //   //console.log(appData)
  //   if (loading) return;
  //    if (!appData) return; 
  //   autoLogoutAtMidnight()
  //   gettasks()
  //   getjc()
  //   //console.log(empall)
  //   if((role=="Sales"  || role=="SME") && currenturl.includes("home")){
  //     showreport()
  //   }
  
  //   // socket.on('newLead', (data) => {
  //   //   console.log(data.message)
  //   //   setshowpopup(data.message)
  //   // });
  const getpintrip=async()=>{
    try{
    const data=await fetchpintrip(cuser)
    setpintrips(data.data)
    console.log(data.data)
    }catch(e){
      console.log(e)
    }
  }
    

  // }, [appData, empall]);

  const getfunnellength=async()=>{
    try{
      const data= await getactivefunnellength("Amit")
      setfunnellength(data.data)
    }catch(err){
      console.log(err)
    }
  }

    useEffect(() => {
      if (!loading) {
        console.log("User:", cuser);
        console.log("Role:", role);
        console.log("Employees:", employeelist.length);
        console.log("Destinations:", destinationlist.length);
        getEmployees();
        autoLogoutAtMidnight()
        if(role && cuser && employeelist){
        gettasks()
        }
        if(role=="Admin"){
        getfunnellength()
        }
        getjc()
        getInfo()
        getpintrip()
        if(role=="TL" || role=="Manager" || role=="Admin" || role=="Sales Support"){
            getmanualfrinfo()
        }
        if((role=="Sales"  || role=="SME") && currenturl.includes("home")){
          showreport()
        }
      }
    }, [loading, cuser, role, employeelist, destinationlist]);

    //  useEffect(() => {
     
    //     gettasks()
       
    // }, [cuser, role, employeelist]);

//   useEffect(() => {
//     // const socket = io(serverurl, {
//     //    transports: ['websocket'], // Ensure the correct transport method is used
//     // });
//     //console.log(socket)
//     socket.on('connect', () => {
//        console.log('Socket connected:', socket.id);
//     });
//     // socket.onAny((event, ...args) => {
//     //   console.log("Socket Event Received:", event, args);
//     // });
    
//     socket.on('newData', (data) => {
//        //console.log(data.message);
//       //console.log(cuser, role)
//         setpendingTasks(pendingTasks+1)
//        // Play notification sound
//       //  const audio = new Audio(newDataSound);
//       //  console.log(audio)
//       //  audio.play();
//        setNewData(data);
  
//     });

//     socket.on('newLead', (data) => {
//       console.log(data.message)
//       setshowpopup(data.message)
//     });

//     socket.on('disconnect', () => {
//        console.log('Socket disconnected');
//     });

//     // Cleanup on unmount
//     return () => {
//        socket.disconnect();
//     };
//  }, []);


 useEffect(() => {
    
     const checksignin = async () => {
      const signin = await getsignin(User.email);
      console.log(signin.data)
      // var signin=[{data:[]}]
      if(signin.data.length>0){
        if(!signin.data[0].logged_in){
          alert("Sign in again")
          logout2(User.email)
          window.location=("/")
        }
      }
    }
    if(User && User.email){
    checksignin()
    }
  
    

  }, [User]);

    

  const getFollowups = async (id) => {
    const data = await fetchActiveFupTrips();
    setfollowupData(data.data);

    //console.log(data2.data)
  };

  const getFollowupbyTripOwner = async (owner, id) => {
    try{
    //console.log("owner")
    const data = await fetchActiveFupTripsbyTripOwner(owner);
    setfollowupData(data.data);
  }catch(err){
    console.log(err)
  }
    //console.log(data2.data)
  };
  //-----------------------------------bday code----------------------------------------------
  var bday=[]
  var bdayname=""
  const todaymonth=new Date().getMonth()+1
  const todaydate=new Date().getDate()
  const todayyear=new Date().getFullYear()
  //console.log(todaydate, todaymonth)
  if(emp?.length){
    for(let i=0;i<emp.length;i++){
      let bdaymonth=new Date(emp[i].dob).getMonth()+1
      let bdaydate=new Date(emp[i].dob).getDate()
    if(bdaymonth== todaymonth && bdaydate== todaydate){
      //bday=true
      //bdayname=emp[i].short_name
      const temp={
        name:emp[i].short_name,
        //year:anntime,
      }
      bday=[...bday, temp]
      // setbday({bday:true, name:emp[i].short_name})
    }
  }
}

var ann=false
var ann=[]
//console.log(todaydate, todaymonth)
if(emp?.length){
  for(let i=0;i<emp.length;i++){
    let annmonth=new Date(emp[i].doj).getMonth()+1
    let anndate=new Date(emp[i].doj).getDate()
  if(annmonth== todaymonth && anndate== todaydate){
    var anntime=todayyear-new Date(emp[i].doj).getFullYear()
    if(anntime>0){
      const temp={
        name:emp[i].short_name,
        year:anntime,
      }
      ann=[...ann, temp]
    }
    
    
  }
}
}
  //-------------------------------------- Notification code------------------------------------------------------------------->
  const fupfinalDate = DateCalc(0);
  
  //const f=followupData.filter(tripdata => tripdata.follow_up.filter(fup => fup.date <= fupfinalDate && fup.status=="Open").length >0)
  const followuptoday = followupData.filter(
    (tripdata) =>
      tripdata.follow_up.filter(
        (fup) => fup.date == fupfinalDate && fup.status == "Open"
      ).length > 0
  );
  const notificationlist2 = followuptoday?.map((tripdata) =>
    tripdata.follow_up.filter((fup) => fup.status == "Open")
  );
  //const notificationlist=notificationlist2.map(fup => Date.parse(fup[0].date+" "+fup[0].time)> fupsomeDate.getTime() ? Date.parse(fup[0].date+" "+fup[0].time)/1000: "")
  const notificationlist = notificationlist2.map(
    (fup) => Date.parse(fup[0].date + " " + fup[0].time) / 10000
  );
  const notify = () => {

    var curtime = new Date();
    //console.log(notificationlist)
    //console.log("running")
    notificationlist.map((timedata) => {
      if (Math.round(timedata) === Math.round(curtime.getTime() / 10000)) {
        alert("You have a follow up scheduled now at " + curtime);
      }
    });
  };
  //setInterval(notify, 2000);
  //-----------------------------------------------------
  var crd=currentreportdata?[...currentreportdata]:[]
  if(filterData && "tl" in filterData){
    if(filterData.tl!==""){
    crd=crd.filter(data=>data.manager==filterData.tl)
    }
  }
  const saveserver = () =>{
    window.localStorage.setItem("server_name",JSON.stringify(server));
  }

  const showreport=async()=>{
    try{
      setloading2(true)
      console.log(cuser, role)
      const data=await fetchaicurrentreport(cuser, role)
      console.log(data.data)

      const temp=data.data.sort((a, b) => a.manager.localeCompare(b.manager))
      setcurrentreportdata(temp)
      const data2=await fetchtaskcount(cuser, role)
      console.log(data2.data)
      settaskcount(data2.data)
      setloading2(false)
    }catch(e){
      console.log(e)
    }
  }

  const get12pm=async(name)=>{
    try{
      setspname(name)
      const data=await get12pmreport(name)
      console.log(data.data)
      const text="Hot Pending: "+data.data.hot.toString()+"\n\n"+"Pot Pending: "+data.data.pot.toString()
      
      alert(text)
    }catch(e){
      console.log(e)
    }
  }

  const leadreport=async(name)=>{
    try{
      setspname(name)
      let startDate=DateCalc(0)
      let endDate=DateCalc(1)
      const data=await searchTripsbycreateddateandOwner(name, startDate, endDate)
      console.log(data.data)
      var finarr=[]
      if(data.data.lead.length>0){
        for(let i=0; i<data.data.lead.length; i++){
          var quoteid=[]
          var data2=[]
          var custidset=[]
          var com=[]
          var comq=[]
          const custid=data.data.cust.filter(c=>c.lead_id==data.data.lead[i].lead_id)
          if(custid.length>0){

          }else{
            data2=await fetchCustomerbyNumber(data.data.lead[i].mobile_number)
            custidset="data" in data2 && data2.data.length>0?data2.data[0].cust_trips.map(data=>data.id):[]
            console.log(data2.data)
          }
          const tripid=data.data.trip.filter(t=>"lead" in t && t.lead.lead_id==data.data.lead[i].lead_id)
          const tripidset=data.data.trip.map(d=>d.trip_id)
          if(tripid.length>0){
            quoteid=data.data.quote.filter(q=>q.trip_id==tripid[0].trip_id)
          }
          if(data2 && "data" in data2 && data2.data.length>0){
            console.log(custidset)
            console.log(tripidset)
            com=findCommonElements(custidset, tripidset)
            console.log(com)
            if(com.length>0){
            comq=data.data.quote.filter(q=>q.trip_id==com[0])
            }
          }
      
          const temp={
            lead_id: data.data.lead[i].lead_id,
            work_done_date: data.data.lead[i].work_complete_date,
            potential: "potential" in data.data.lead[i] && data.data.lead[i].potential?"Yes":"No",
            cancelled: data.data.lead[i].canc_reason,
            cust:custid.length>0?custid[0].cust_id:(data2.data.length>0?data2.data[0].cust_id:""),
            cust_status:custid.length>0?custid[0].follow_up.status:(data2.data.length>0?data2.data[0].follow_up.status:""),
            cust_roc:custid.length>0?custid[0].follow_up.roc:(data2.data.length>0?data2.data[0].follow_up.roc:""),
            trip:tripid.length>0?tripid[0].trip_id:(com.length>0?com[0]:""),
            quote:quoteid.length>0?quoteid[0].quote_id:(comq.length>0?comq[0].quote_id:""),
          }
          finarr=[...finarr, temp]
        }
      }
      
      setopentable2(true)
      console.log(finarr)
      setleaddisplayarr(finarr)
    }catch(e){
      console.log(e)
    }
  }

  const hotreport=async(name)=>{
    try{
      setspname(name)
      let startDate=DateCalc(0)
      let endDate=DateCalc(1)
      const data=await searchpotentialhot(name, startDate, endDate)
      console.log(data.data)
      sethotdisplayarr(data.data)
      var finarr=[]
      
      // const text="Hot Pending: "+data.data.hot.toString()+"\n\n"+"Pot Pending: "+data.data.pot.toString()
      setopentable3(true)
      console.log(finarr)
      
    }catch(e){
      console.log(e)
    }
  }

  const handletripSearch2=async()=>{
    if(searchData3.number){

    
    const temp=getLastTenChars(searchData3.number)
    console.time("api");
    const data=await fetchTripsbyNumber(temp)
    console.timeEnd("api");
    if(data.data.length==0){
      settripData([{trip_id:"No trip found", quote:[""]}])
    }else{
      settripData(data.data)
    }
    }else if(searchData3.name){
      const data=await fetchTripsbyName(searchData3.name)
      const temp=data.data.filter(t=>t.trip_owner==cuser)
    settripData(temp)
    }
  } 

  const handleleadSearch2=async()=>{
    if(searchData3.number){

    
    const temp=getLastTenChars(searchData3.number)
    const data=await fetchLeadsbyNumber(temp)
    console.log(data.data)
    if(data.data.length==0){
      setleadData([{lead_id:"No lead found"}])
    }else{
      setleadData(data.data)
    }
    }else if(searchData3.name){
      const data=await fetchLeadsbyName(searchData3.name)
      if(data.data.length==0){
        setleadData([{lead_id:"No lead found"}])
      }else{
        const temp=data.data.filter(t=>t.trip_owner==cuser)
      setleadData(temp)
      }
    }
  } 

  const handlecustSearch2=async()=>{
    if(searchData3.number){

    
    const temp=getLastTenChars(searchData3.number)
    const data=await fetchCustomerbyNumber(temp)
    console.log(data.data)
    if(data.data.length==0){
      setcustData([{cust_id:"No customer found"}])
    }else{
      setcustData(data.data)
    }
    }else if(searchData3.name){
      alert("Cannot search customer by name")
    }
  } 

  const cleartable=()=>{
    setopentable2(false)
    setopentable3(false)
    settripData([])
  }

  const showfrleads=()=>{
    //console.log(counter)
    alert(counter)
  }

  const generatelink=async()=>{
    let mail=prompt("Enter email id:")
              const data=await loginemail(mail)
              console.log(data)
              // auth
              // .createCustomToken("debayan.ghosh@jetovacations.com")
              // .then((customToken) => {
              //   return customToken;
              // })
              // .catch((error) => {
              //   console.log('Error creating custom token:', error);
              // });
          }

  const reactivate=async()=>{
    const data=await reactivatebyNumber(getLastTenChars(searchData3.number))
    if (
        data.status == 200 ||
        201 ||
        202 ||
        203 ||
        204 ||
        205 ||
        206 ||
        207
      ){
        alert("Latest trip id activated for mobile number: "+getLastTenChars(searchData3.number))
      }else{
        alert("Something went wrong. Try again")
      }
  }

  const getasset=async()=>{
    const data = await fetchAsset();
    console.log(data.data)
    const temp=data.data[0].assetlist.filter(a=>a.owner==cuser)
    console.log(temp)
    if(temp.length>0){
      var text=""
      for(let i=0;i<temp.length;i++){
        text=text+"Asset Type: "+temp[i].asset_type+" || Identifier: "+temp[i].identifier+"\n\n"
      }
      alert(text)
    }else{
      alert("No asset found")
    }
  }

  var offset=0
  var bannerarray=[
    {isTaskCompleted:l2tasks && l2tasks.length>0?0:1,message: l2tasks && l2tasks.length>0?l2tasks.map(t=><span><a href={"/taskdataentry/"+t}>{t+" || "}</a></span>):"", header: "Delayed tasks:", role:role },
    {isTaskCompleted:l3tasks && l3tasks.length>0?0:1,message: l3tasks && l3tasks.length>0?l3tasks.map(t=><span><a href={"/taskdataentry/"+t}>{t+" || "}</a></span>):"", header: "Critically Delayed tasks:", role:role},
    {isTaskCompleted:myfr && myfr.length>0?0:1,message: myfr && myfr.length>0?myfr.map(t=><span><a href={"/lead/"+t}>{t+" || "}</a></span>):"", header: "Fast Reach Leads:", role:role },
  ]
  if(role !=="Admin"){
    offset=120*bannerarray.reduce((accumulator, currentValue) => accumulator + !currentValue.isTaskCompleted, 0)
  }else{
    offset=75*bannerarray.reduce((accumulator, currentValue) => accumulator + !currentValue.isTaskCompleted, 0)
  }
  
  //offset=70
  //console.log(offset)

     // spinner / skeleton / blank screen

  //console.log( l2tasks.length, l3tasks.length, myfr.length)

  return (
    <div>
    {l1tasks === null ||
  l2tasks === null ||
  l3tasks === null?(<Loading message={`Loading data...`} />):(
    <div style={{ paddingTop: offset }}>
  
  <StickyReminderBanner
 bannerarray={bannerarray}
/>
    <Paper variant="outlined" className={classes.paper} elevation={15}>
      <div align="center">
      
        <Typography variant="h4" className={classes.headertext}>
          {" "}
          Jeto Vacations{" "} <sup>v52</sup>
          
        </Typography>
        {role!=="External"?(
          <div>
          <button type="button" onClick={handleOpen}>
          User Guide ( User:{User?.email ? User.email : ""}){" "} Role:{role}
        </button>
        <i className="fa fa-bell"></i>
        <h6 className={classes.link}> Working Pairs: Netlify-Heroku | Vercel-AWS | Netlify-backup-Azure || Client Links: <a href="https://jetocrm.netlify.app/" rel="noreferrer" target="_blank">Netlify</a> | <a href="https://jeto-crm-client.vercel.app/" rel="noreferrer" target="_blank">Vercel</a> | <a href="https://jetocrm-client-netlify-backup.netlify.app/" rel="noreferrer" target="_blank">Netlify Backup</a>&nbsp; || Server Links: <a href="https://jetovacations.in" rel="noreferrer" target="_blank">AWS</a> | <a href="https://jetocrmserver-cbf5081ff15c.herokuapp.com/" rel="noreferrer" target="_blank">Heroku</a> | <a href="https://jeto-crm-server.onrender.com" rel="noreferrer" target="_blank">Render</a> | <a href="https://www.jetovacations.in" rel="noreferrer" target="_blank">Railway</a> || Lead request link: <a href={url+"/leadcaptureform"} rel="noreferrer" target="_blank"> Link</a> || <a href={url+"/tripdataentry/200000"} rel="noreferrer" target="_blank"> Trip 200k</a> || <a href={url+"/quotedataentry/300000"} rel="noreferrer" target="_blank"> Quote 300k</a>|| <a href={url+"/lead/250000"} rel="noreferrer" target="_blank"> Lead 250k</a> || <a href={url+"/tripdataentry/227919/paymentupdate"} rel="noreferrer" target="_blank"> Payment 227919</a> || <a href={url+"/custdataentry/120000"} rel="noreferrer" target="_blank"> Cust 120k</a> || <a href={url+"/taskdataentry/5000"} rel="noreferrer" target="_blank"> Task 5k</a> || <a href="https://docs.google.com/document/d/1lijJBZgv9mq2iyzKwwg1C4q_pCu2pu58Nq_raNKbz24/edit">Definitions</a> || <a href="https://docs.google.com/spreadsheets/d/1v3-6_xyni9sicxN3Ovf8akqj83E2zYWYLpw3tF2kgZg/edit?gid=0#gid=0">Offers</a> || <button onClick={handleOpen2}>Process</button> <button onClick={()=>handleOpen4()}>Incoming Calls</button> <a href="/taskdataentry"><button >Create Task</button></a> || <a href="/leadrules">Set Rules</a> || <button onClick={()=>getasset()}>My Asset</button> 
      </h6>
          </div>
        ):("")}

               
      
                <Dialog open={open2} onClose={handleClose2}>
                <div >
      <h2 className={classes.headertext}>Daily Process</h2>
      <p className={classes.headertext}>
      10:30 - 11:00 ---	Hot & Potential leads call, clear Requested Trips <br/>
11:00 - 11:30	--- Work on HOT edit <br/>
11:30 - 12:30	--- (First Round 10 Leads) Call on new leads, Quote Share on new leads, Call recording Share <br/>
12:30 - 16:00	--- Follow-up (Call & Whatsapp both) <br/>
16:00 - 17:00	--- Call on new open lead and share sample package if call not picked <br/>
17:00 - 17:30 --- Training <br/>
17:30 - 19:00	--- Quote edit, MARK HOT AS PER PROCESS, 2nd round fup as and when required <br/>
19:00 - 19:30 --- Reporting 
      </p>
    </div>
<br></br>
<div >
      <h2 className={classes.headertext}>Daily Process-TL</h2>
      <p className={classes.headertext}>
      Verify status of Yesterday projections<br/>
      Update HOT & High profit trips<br/>
      2PM check effective calls<br/>
      Tickets check <br/>
      Booker trips check <br/>
      QE check <br/>
      Hot marking <br/>
      </p>
    </div>
   
          {/* <br></br>
          
          <br></br> */}
          {/* {cuser=="Amit"?body3:""} */}
        </Dialog>

           <Dialog open={open5} onClose={handleClose5}>
                <div >
      <h2 className={classes.headertext}>Number</h2>
            <Table>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Number</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Number</TableCell>
              </TableRow>
            </Table>
   
        </div>
        </Dialog>

        <Dialog open={open4} onClose={handleClose4}>
        <Table>
        <TableHead>
              <TableCell>Type</TableCell>
              <TableCell>Id</TableCell>
              <TableCell>Number</TableCell>
              <TableCell>Name</TableCell>
              <TableCell>Owner</TableCell>
             
        </TableHead>
          {currentset && currentset.map(s=>{
            return    <TableRow>
              <TableCell>{s.type}</TableCell>
              <TableCell>{s.trip_id}</TableCell>
              <TableCell>{s.number}</TableCell>
              <TableCell>{s.name}</TableCell>
              <TableCell>{s.owner}</TableCell>
              
            </TableRow>
            
          })}
          </Table>
        </Dialog>
        <Modal open={open} onClose={handleClose}>
          {body}
        </Modal>
      </div>
     
     {/* {role=="Admin" || role=="Sales Support"?(
      <div>
        {showpopup?(<BlinkingText variant="h3">{"New lead received for Fast Reach with lead id: "+showpopup}</BlinkingText>):("")}
      </div>
     ):("")} */}
     {cuser=="Debayan" || cuser=="Tarun"?(<button onClick={forceLogoutByEmail}>Force Logout</button>):("")}
     {role=="TL" || role=="Manager" || role=="Admin" || role=="Operations" || role=="Operations-TL" || role=="Product" || role=="Support" || role=="HR" ?(<div align="center">
     <p>Trips within 10 days and still in JC:  {convtripData} || Amit Funnel: {funnellength}</p>
        {/* {convtripData.map(trip=>{return(
          <p>{trip.trip_id+"("+trip.trip_owner+")"}</p>)})} */}
          <p>Tasks pending on: Sales:  {taskcount2}, Admin: {taskcount3}, Operations (Over 24 hours): {taskcount4}, Support (Over 24 hours): {taskcount5}</p>
          {taskcount6 && taskcount6>0?(
          <BlinkingText>Hotel Booking Tasks:  {taskcount6}, Deadline Passed: {taskcount7}</BlinkingText>
          ):("")}
          {l1tasks && l1tasks.length>0?(
          <BlinkingText>Open tasks:  {l1tasks.map(t=><span><a href={"/taskdataentry/"+t}>{t+" || "}</a></span>)}</BlinkingText>
          ):("")}
          <hr></hr>
          {/* {l2tasks && l2tasks.length>0?(
          <BlinkingText2>Delayed tasks:  {l2tasks.map(t=><span><a href={"/taskdataentry/"+t}>{t+" || "}</a></span>)}</BlinkingText2>
          ):("")}
          <hr></hr>
          {l3tasks && l3tasks.length>0?(
          <BlinkingText3>Critically delayed tasks:  {l3tasks.map(t=><span><a href={"/taskdataentry/"+t}>{t+" || "}</a></span>)}</BlinkingText3>
          ):("")} */}
     </div>):("")}
     {/* {myfr && myfr.length>0?(
      <div align="center">
        <BlinkingText3>Fast Reach Leads:  {myfr.map(t=><span><a href={"/lead/"+t}>{t+" || "}</a></span>)}</BlinkingText3>
      </div>
     ):("")} */}
     {servermarker?(<p>Server issue</p>):("")}
          {pintrips && pintrips.length>0?(<div>
          <p>Pinned Trips: 
            {pintrips.map(trip=>
          <span>{" "+ trip.trip_id+" ||"}</span>)}</p>
          </div>):("")}
          
      
      {role!=="External" && role!=="Ex-employee"?(
        <div>
        {bday && bday.length>0 && bday.map(b=>
          <div align="center">
        <h1 className={classes.headertext}>Happy Birthday {b.name}!</h1>
      </div>
        )}
      {ann && ann.length>0 && ann.map(a=>
        <div align="center">
        <h1 className={classes.headertext}>Congratulations {a.name} for completing {a.year==1?a.year+" year":a.year+" years"} at Jeto Vacations!</h1>
      </div>
      )}
      {info && info.show?(
        <div align="center">
        <h3 className={classes.headertext2}>{info.data} (Updated on:{String(info.date.split("T").slice(0,1))})</h3>
        
      </div>
      ):("")}
      <div align="center">
      {role=="TL" || role=="Admin" || role=="Product" || role=="Operations-TL" || role=="Sales"  || role=="SME" || role=="Manager" || role=="Sales Support" || role=="Operations"  || role=="Accounts" || role=="Support" ?(
        <Button href="/home" variant="outlined" className={classes.button}>
          Home
        </Button>
      ):("")}
        {role=="TL" || role=="Admin" || role=="Product" || role=="Operations-TL" || role=="Manager"?(
        <Button href="/tlhome" variant="outlined" className={classes.button}>
          TL Home
        </Button>
      ):("")}
      {/* {role=="TL" || role=="Admin" || role=="Product" || role=="Operations-TL" || role=="Sales" || role=="Manager"?(
        <Button
          href="/custdataentry"
          variant="outlined"
          className={classes.button}
        >
          Add Customer
        </Button>
      ):("")} */}
        {/* <Button
          href="/searchcust"
          variant="outlined"
          className={classes.button}
        >
          Search Customers
        </Button> */}
        {role=="Product" || role=="Admin" || role=="Sales" || role=="SME" || role=="TL" || role=="Manager"?(
          <Button
          href="/listtripsdata"
          variant="outlined"
          className={classes.button}
        >
          View Trips
        </Button>
        ):("")}
        
        {role=="Product" || role=="Admin" || role=="SME" || role=="TL" || role=="Manager" || role=="Sales Support" || role=="Operations" || role=="Operations-TL" || role=="Support"  || role=="Accounts" ?(
        <Button
          href="/postsalesdata"
          variant="outlined"
          className={classes.button}
        >
          Post Sales
        </Button>
      ):("")}
      {/* {role=="Product" || role=="Admin" || role=="Operations" || role=="Operations-TL" || role=="Support" || role=="Marketing" ?(
        <Button
          href="/chat"
          variant="outlined"
          className={classes.button}
        >
          Chat
        </Button>
      ):("")} */}
      {role=="Product" || role=="Admin" || role=="TL" || role=="Operations-TL" || role=="Sales" || role=="SME" || role=="Manager" || role=="Operations"?(
        <Button
          href="/listhoteldata"
          variant="outlined"
          className={classes.button}
        >
          View Hotels
        </Button>
      ):("")}
      {role=="Product" || role=="Admin" || role=="TL" || role=="Operations-TL" || role=="Sales" || role=="SME" || role=="Manager" || role=="Operations"?(
        <Button
          href="/listtourdata"
          variant="outlined"
          className={classes.button}
        >
          View Tours
        </Button>
      ):("")}
        {role=="Admin" || role=="TL" || role=="Sales Support" || role=="Manager" ?(
        <Button
          href="/salessupport"
          variant="outlined"
          className={classes.button}
        >
          Sales Support
        </Button>
        ):("")}
        {/* {role=="Admin" || role=="Manager" || role=="HR" || cuser=="Tarun"?( */}
        <Button
          href="/listemployeedata"
          variant="outlined"
          className={classes.button}
        >
          View Employees
        </Button>
        {/* ):("")} */}
        {role=="Admin" || role=="HR" || cuser=="Tarun" || cuser=="Vipin" || cuser=="Pawan"?(
        <Button
          href="/listhrdata"
          variant="outlined"
          className={classes.button}
        >
          HR Portal
        </Button>
        ):("")}
         {role=="Admin" || role=="HR" || cuser=="Tarun" || cuser=="Vipin" || cuser=="Pawan"?(
        <Button
          href="/listassetdata"
          variant="outlined"
          className={classes.button}
        >
          Asset Management
        </Button>
        ):("")}
        {/* {role=="Product" || role=="Admin" || role=="Sales" || role=="SME" || role=="TL" || role=="Manager"?(
        <Button
          href="/listquotedata"
          variant="outlined"
          className={classes.button}
        >
          View Quotes
        </Button>
      ):("")} */}
      {/* {role=="Product" || role=="Admin" || role=="TL" || role=="Sales" || role=="SME" || role=="Manager"  || role=="Operations-TL"?(
        <Button
          href="/listfddata"
          variant="outlined"
          className={classes.button}
        >
          View FDs
        </Button>
      ):("")} */}
        <Button
          href="/listtaskdata"
          variant="outlined"
          className={classes.button}
        >
          View Tasks
        </Button>
        {/* <Button
          href="/viewvoucher"
          variant="outlined"
          className={classes.button}
        >
          Voucher
        </Button> */}
        {role=="Admin" || role=="TL" || role=="Product" || role=="Manager"?(
        <Button
          href="/analyticsdata"
          variant="outlined"
          className={classes.button}
        >
          Analytics
        </Button>
        ):("")}
        {role=="Admin" || role=="TL" || role=="Product" || role=="Marketing" || role=="Manager"?(
        <Button
          href="/analyticsadmin"
          variant="outlined"
          className={classes.button}
        >
          Analytics Admin
        </Button>
        ):("")}
        {role=="Admin"  || role=="Product" || role=="Manager" || role=="Operations-TL"?(
        <Button
          href="/productanalytics"
          variant="outlined"
          className={classes.button}
        >
          Product Analytics 
        </Button>
        ):("")}
        <Button
          href="/knowledgecenter"
          variant="outlined"
          className={classes.button}
        >
          Knowledge Center
        </Button>
        
        {role=="Admin" || role=="TL" || role=="SME"|| role=="Product" || role=="Manager" || role=="Accounts" || cuser=="Tarun" || role=="Operations-TL"?(
          <Button
          href="/dashboard"
          variant="outlined"
          className={classes.button}
        >
          Dashboard
        </Button>
        
        
        ):("")}
        
      
        {/* {role=="Product" || role=="Admin" || role=="TL" || role=="Operations-TL" || role=="Sales" || role=="SME" || role=="Manager" || role=="Operations"?(
          <Button
          href="/hotelapi"
          variant="outlined"
          className={classes.button}
        >
          Hotel Search
        </Button>
      ):("")}
        {role=="Product" || role=="Admin" || role=="TL" || role=="Operations-TL" || role=="Sales" || role=="SME" || role=="Manager" || role=="Operations"?(
        <Button
          href="/flightapi"
          variant="outlined"
          className={classes.button}
        >
          Flight Search
        </Button> 
      ):("")} */}
        
      {role=="Product" || role=="Admin" || role=="TL" || role=="Operations-TL" || role=="Support" || role=="Manager" || role=="Marketing"?(
      
          <Button href="/lead" variant="outlined" className={classes.button}>
          Leads
        </Button>
        
      ):("")}
   
        {role=="Admin" || role=="Manager" || role=="Support" || role=="TL" || role=="Operations-TL" || role=="Product" || role=="Marketing" || role=="Accounts" || cuser=="Asgar"?(
          <Button href="/marketing" variant="outlined" className={classes.button}>
          Marketing
        </Button>
        
        
        ):("")}
        {role=="Admin" || role=="Product" || role=="Manager"?(
          <Button href="/info" variant="outlined" className={classes.button}>
          Info
        </Button>
        
        
        ):("")}
        {cuser=="Debayan"?(
          
        <Button href="/bulkmsg" variant="outlined" className={classes.button}>
          Analytics3
        </Button>
        
        
        ):("")}

         {cuser=="Debayan" || cuser=="Amit"?(
          
        <Button href="/projects" variant="outlined" className={classes.button}>
          Projects
        </Button>
        
        
        ):("")}

        {/*role=="Admin"?(
          
          <Button onClick={()=>generatelink()} variant="outlined" className={classes.button}>
            Generate Link
          </Button>
          
          ):("")*/}
        {role=="Admin" || role=="Manager" || role=="Product" || role=="Accounts" || role=="Operations-TL"?(
        <Button
          href="/listsupplierdata"
          variant="outlined"
          className={classes.button}
        >
          View Suppliers
        </Button>
    
        ):("")}
        
        <Button variant="outlined" onClick={logout} className={classes.button}>
          Logout
        </Button>
      </div>
      </div>
      ):(
         <Button variant="outlined" onClick={logout} className={classes.button}>
          Logout
        </Button>
      )}

      {role=="Admin" || role=="TL" || role=="Manager" || role=="Product"?(<div align="center">
          <br></br>
        <Button onClick={preventDoubleClick(showreport)}  variant="contained" color="secondary" align="center" className={classes.button}>Show Report</Button>|| 
        {/* <Button onClick={showfrleads}>{counter?counter.length:""}</Button>  */}
        || <Button onClick={()=>setshowdef(!showdef)}>Definitions</Button> || Fast Reach: {manualfr && manualfr.length>0?manualfr.map(v=><a href={"/lead/"+v.lead_id}>{v.lead_id+" || "}</a>):""}
        <br></br>
        </div>):("")}
        {loading2?(<Typography variant="h2">{"Loading..."}</Typography>):("")}
        {currentreportdata?(
          <div>
          {taskcount && taskcount>0?( <p>Task Pending:{taskcount}</p>):("")}
          <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="tl">TL</InputLabel>
                <Select displayEmpty classname={classes.textField} labelId="tl" InputLabelProps={{ shrink: true }}  onChange={(e)=> setfilterData({...filterData, tl:e.target.value})}>
                <MenuItem value={""}>Clear</MenuItem>
                {eData && eData.map(emp => {
                  return <MenuItem value={emp.short_name}>{emp.name}</MenuItem>})}
                  
                </Select>
                </FormControl>
          <Table>
          <TableRow>
          <TableCell>Name</TableCell>
          <TableCell>TL</TableCell>
            <TableCell>Lead Worked/Assigned</TableCell>
            <TableCell>Open Cust FUP</TableCell>
            <TableCell>FUP Pending</TableCell>
            <TableCell>Yesterday FUP Pending</TableCell>
            <TableCell>New Quote/Edit Quote</TableCell>
            <TableCell>Answered/Eff/Talk Time</TableCell>
            <TableCell>Trip with Quote</TableCell>
            <TableCell>Hot Marked</TableCell>
            <TableCell>Quote Pending</TableCell>
            <TableCell>No Trips</TableCell>
            <TableCell>Quote Missing</TableCell>
            {/* <TableCell>Call Missed</TableCell> */}
            <TableCell>12pm Report</TableCell>
            <TableCell>Lead Report</TableCell>
            <TableCell>Booker Leads</TableCell>
          </TableRow>
          {crd && crd.map(data=> {return(
            <TableRow>
            <TableCell>{data.name+" ("+data.manager+")"}</TableCell>
            <TableCell>{getTL(data.name)}</TableCell>
            <TableCell>{data.workedlead+"/"+data.assignedlead}</TableCell>
            <TableCell>{data.custfup}</TableCell>
            <TableCell>{data.pendingfup}</TableCell>
            <TableCell>{data.pendingyesterdayfup}</TableCell>
            <TableCell>{data.nq+"/"+data.eq}</TableCell>
            {/* <TableCell>{data.eq-data.nq+(data.nq-data.workedlead>0?(data.nq-data.workedlead):0)}</TableCell> */}
            <TableCell>{data.callanswered+"/"+data.effectivecalls+"/"+data.talktime}</TableCell>
            <TableCell>{data.tq}</TableCell>
            <TableCell>{data.hotmade}</TableCell>
            <TableCell>{data.quotepending}</TableCell>
            <TableCell>{data.tripcreated+"/"+data.custnotrip}</TableCell>
            <TableCell>{data.quotemissing}</TableCell>
            {/* <TableCell>{data.callmissed}</TableCell> */}
            <TableCell>
            <Button
            onClick={()=>get12pm(data.name)}
            variant="contained"
            
            color="secondary"
            className={classes.smallbutton2}
          >
            12pm
          </Button></TableCell>
          <TableCell>
            <Button
            onClick={()=>leadreport(data.name)}
            variant="contained"
            
            color="secondary"
            className={classes.smallbutton2}
          >
           Lead
          </Button></TableCell>
          <TableCell>
            <Button
            onClick={()=>hotreport(data.name)}
            variant="contained"
            
            color="secondary"
            className={classes.smallbutton2}
          >
           Booker
          </Button></TableCell>
          </TableRow>
          )})}
          {!(role=="Sales" || role == "SME")?(
          <TableRow>
          <TableCell>Total</TableCell>
          <TableCell></TableCell>
            <TableCell>{getSumByKey(crd, "workedlead")+" / "+getSumByKey(crd, "assignedlead")}</TableCell>
            <TableCell>{getSumByKey(crd, "custfup")}</TableCell>
            <TableCell>{getSumByKey(crd, "pendingfup")}</TableCell>
            <TableCell>{getSumByKey(crd, "pendingyesterdayfup")}</TableCell>
            <TableCell>{getSumByKey(crd, "nq")+"/"+getSumByKey(crd, "eq")}</TableCell>
            <TableCell>{getSumByKey(crd, "callanswered")+"/"+getSumByKey(crd, "effectivecalls")+"/"+getSumByKey(crd, "talktime")}</TableCell>
            <TableCell>{getSumByKey(crd, "tq")}</TableCell>
            <TableCell>{getSumByKey(crd, "hotmade")}</TableCell>
            <TableCell>{getSumByKey(crd, "quotepending")}</TableCell>
            <TableCell>{getSumByKey(crd, "custnotrip")}</TableCell>
            <TableCell>{getSumByKey(crd, "quotemissing")}</TableCell>
            {/* <TableCell>{getSumByKey(crd, "callmissed")}</TableCell> */}
     
          </TableRow>
        ):("")}
        </Table>
        <br></br>
        <br></br>
        <h2>{"   "+spname}</h2>
        <br></br>
        {opentable2?(<div>
       
          <Table>
          <TableRow>
          
            <TableCell>Lead Id</TableCell>
            <TableCell>Work Done</TableCell>
            <TableCell>Potential</TableCell>
            <TableCell>Cancelled</TableCell>
            <TableCell>Customer Id</TableCell>
            <TableCell>Customer Status</TableCell>
            <TableCell>Customer RoC</TableCell>
            <TableCell>Trip Id</TableCell>
            <TableCell>Quote Id</TableCell>
          </TableRow>
          {leaddisplayarr.map(data=>{return(
            <TableRow>
            <TableCell>{data.lead_id}</TableCell>
            <TableCell>{data.work_done_date}</TableCell>
            <TableCell>{data.potential}</TableCell>
            <TableCell>{data.cancelled}</TableCell>
            <TableCell>{data.cust}</TableCell>
            <TableCell>{data.cust_status}</TableCell>
            <TableCell>{data.cust_roc}</TableCell>
            <TableCell>{data.trip}</TableCell>
            <TableCell>{data.quote}</TableCell>
            </TableRow>
          )})}
          </Table>
        </div>):("")}
        </div>
        ):("")}
        <br></br>
        <br></br>
        {opentable3?(<div>
          <Table>
          <TableRow>
          
            <TableCell>Trip Id</TableCell>
            <TableCell>Why HOT</TableCell>
            <TableCell>Start Date</TableCell>
            <TableCell>Cust Name</TableCell>
            <TableCell>Destination</TableCell>
            <TableCell>Last Comment</TableCell>
            <TableCell>Previous Comment</TableCell>
          </TableRow>
          {hotdisplayarr.map(data=>{return(
            <TableRow>
            <TableCell>{data.trip_id}</TableCell>
            <TableCell>{data.why_hot}</TableCell>
            <TableCell>{data.start_date}</TableCell>
            <TableCell>{data.cust_name}</TableCell>
            <TableCell>{data.destination}</TableCell>
            <TableCell>{data.last_comment}</TableCell>
            <TableCell>{data.prev_comment}</TableCell>
            </TableRow>
          )})}
          </Table>
        </div>):("")}
        {role!=="External"  && role!=="Ex-employee"?(
        <FormGroup row className={classes.formgroup}>
        <TextField
            variant="standard"
            label="Enter mobile number"
            className={classes.textField}
            onChange={(e) =>
              setsearchData3({ ...searchData3, number: e.target.value })
            }
          />
           <TextField
            variant="standard"
            label="Enter name"
            className={classes.textField}
            onChange={(e) =>
              setsearchData3({ ...searchData3, name: e.target.value })
            }
          />
            <Button
            onClick={handletripSearch2}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Trip Search
          </Button>
           <Button
            onClick={handleleadSearch2}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Lead Search
          </Button>
            <Button
            onClick={handlecustSearch2}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Cust Search
          </Button>
           {tripData && tripData.length>0?(
             <Button
            onClick={reactivate}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Re-activate
          </Button>
          ):("")}
          <Button
            onClick={cleartable}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Clear
          </Button>
          </FormGroup>
        ):("")}
        {leadData && leadData.length>0?(
            <Table>
            {leadData.map(t=>{return(
              <TableRow>
                  <TableCell>
                      <a href={"/lead/"+t.lead_id} target="_blank"  rel="noreferrer">Lead Id: {t.lead_id} || {t.work_complete?"Work Done":"Work Not Done"} || {t.cust_create?"Active":"Cancelled"}</a>
                  </TableCell>
                  
                  
              </TableRow>
            )})}
            </Table>
          ):("")}
           {custData && custData.length>0?(
            <Table>
            {custData.map(t=>{return(
              <TableRow>
                  <TableCell>
                      <a href={"/custdataentry/"+t.cust_id}>Cust Id: {t.cust_id}</a>
                  </TableCell>
                  {"cust_trips" in t && t.cust_trips.length>0 && t.cust_trips.map(q=>{return(
                    <TableCell>  
                    <a href={"/tripdataentry/"+q.id}>Trip Id: {q.id}</a>
                  </TableCell>
                  )})}
                  
              </TableRow>
            )})}
            </Table>
          ):("")}
          {tripData && tripData.length>0?(
            <Table>
            {tripData.map(t=>{return(
              <TableRow>
                  <TableCell>
                      <a href={"/tripdataentry/"+t.trip_id}>Trip Id: {t.trip_id} ({t.trip_status})</a>
                  </TableCell>
                  {t.quote.map(q=>{return(
                    <div>
                    {t.quote.length-t.quote.indexOf(q)<5?(
                      <div>
                  <TableCell>  
                    <a href={"/quotedataentry/"+q}>Quote Id: {q}</a>
                  </TableCell>

                      </div>
                    ):("")}
                   
                  </div>
                  )})}
                  
              </TableRow>
            )})}
            </Table>
          ):("")}
          {showdef?(
            <div align="center">
            <img src={Hdef} height={1000} width={1000} alt="ImageText"></img>
            </div>
          ):("")}
        
    </Paper>
      </div>
    )}
    </div>
  );
};

export default Navbar;
